import React from "react";
import { Form, Checkbox, Col, Row } from "antd";

const TestsForm = ({form, initValues=[], tests, readonly=false}) => {
    const {getFieldDecorator} = form
    const selectedTestIds = new Set(initValues.map(({ id }) => id))

    return(
        <>
            <Row>
                {tests.map((value, index) => (
                    <div key={index}>
                    <Col xs={{offset: 1, span: 7}}>
                        <Form.Item>
                            {getFieldDecorator(`test_id[${index}]`, {initialValue: selectedTestIds.has(value.id)})(
                                <Checkbox defaultChecked={selectedTestIds.has(value.id)} disabled={readonly == true}>{value.name}</Checkbox>
                            )}
                            <h6 style={{fontSize: 14}}>{value.description}</h6>
                        </Form.Item>
                    </Col>
                    </div>
                ))}
            </Row>
        </>
    )
}

export default TestsForm
